// removed by extract-text-webpack-plugin
module.exports = {"savings-slider":"src-components----SavingsSlider-module---savings-slider---3vHcu","estimated-savings":"src-components----SavingsSlider-module---estimated-savings---1BHqq","slider":"src-components----SavingsSlider-module---slider---1LRzE","label":"src-components----SavingsSlider-module---label---1vqRx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SavingsSlider.module.scss
// module id = 205
// module chunks = 35783957827783 277043050311175